import styled from 'styled-components';
import { Button, Text } from '@lmn/design-system';
import { safeGap } from '../../../../styles/mixins';

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  ${safeGap('16px')};
`;

export const ModalPrimaryButton = styled(Button)`
  flex-grow: 1;
`;

export const ModalImage = styled.img`
  width: 88px;
  height: 88px;
  margin-bottom: 16px;
`;

export const ModalTitle = styled(Text).attrs({ variant: 'Title4' })`
  margin-bottom: 8px;
`;

export const ModalBody = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
